import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-wrap font-size-12-600" }
const _hoisted_2 = { class: "mt-10" }
const _hoisted_3 = { class: "d-flex mt-4 justify-center ga-6" }
const _hoisted_4 = { class: "mt-10" }
const _hoisted_5 = { class: "d-flex align-center ga-1 font-size-18-600" }
const _hoisted_6 = { class: "d-flex" }
const _hoisted_7 = { class: "round-primary-button primary-background-button-color" }

import router from '@/router';
import {reactive, computed, onMounted} from 'vue';
import {useSettingsStore} from '@/api/store/settings';
import {useUserStore} from '@/api/store/user';
import RoundButton from "@/components/custom/RoundButton.vue";
import Icon from "@/components/Icons/Icon.vue";
import {ordersService} from "@/api/services/order";
import OrderCard from "@/views/OrdersComponents/OrderDetails/OrderCard.vue";
import CardComponent from "@/components/custom/CardComponent.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ShopView',
  setup(__props) {

const settingsStore = useSettingsStore();
const userStore = useUserStore();

const setAppColor = settingsStore.settings.buttonColor2

const state = reactive({
  items: [] as any[],
});

const getOrders = () => {
  ordersService.index(
    { sorting: "created_at,desc", per_page: 2 },
    { skipGlobalLoading: true }
  ).then((response) => {
    state.items = [...response.data]
  });
}

const getClinicAvatar = computed(() => {  
  const primaryPath = userStore?.user?.file?.file_path
  if (primaryPath) return primaryPath
  
  const fallbackPath = userStore?.user?.clinic?.image?.file?.file_path
  return fallbackPath
})

const getVisibleNaturalDispensaryInApp = computed(() => {
  return settingsStore?.settings?.visibleNaturalDispensaryInApp ?? false
})

onMounted(getOrders);

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    class: "px-0",
    style: {"min-height":"100%"}
  }, {
    default: _withCtx(() => [
      _createElementVNode("section", null, [
        _createVNode(_component_v_card_title, { class: "font-size-18-600" }, {
          default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
            _createTextVNode(" My Clinic Categories ", -1)
          ]))]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_1, [
          _createVNode(RoundButton, {
            icon: "service-icon",
            label: "Services",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({ name: 'clinic-shop', params: { category: 'services'} })))
          }),
          _createVNode(RoundButton, {
            icon: "package-icon",
            label: "Packages",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(router).push({ name: 'clinic-shop', params: { category: 'packages'} })))
          }),
          _createVNode(RoundButton, {
            icon: "program-icon",
            label: "Programmes",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(router).push({ name: 'clinic-shop', params: { category: 'programmes'} })))
          }),
          _createVNode(RoundButton, {
            icon: "product-icon",
            label: "Products",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(router).push({ name: 'clinic-shop', params: { category: 'products'} })))
          })
        ])
      ]),
      _createElementVNode("section", _hoisted_2, [
        _createVNode(_component_v_card_title, { class: "font-size-18-600" }, {
          default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
            _createTextVNode(" Shop By Supplier ", -1)
          ]))]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_3, [
          (getVisibleNaturalDispensaryInApp.value)
            ? (_openBlock(), _createBlock(_component_v_sheet, {
                key: 0,
                class: "logo-container-content nd-logo-border",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(router).push({name: 'natural-dispensary'})))
              }, {
                default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                  _createElementVNode("div", {
                    style: {backgroundImage: `url('/img/tnd_hands_logo.png'`},
                    class: "logo-container-image"
                  }, null, -1)
                ]))]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_v_sheet, {
            class: "logo-container-content clinic-logo-border secondary-background-button-color",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(router).push({ name: 'clinic-shop' })))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                style: _normalizeStyle({backgroundImage: `url(${getClinicAvatar.value}`}),
                class: "logo-container-image"
              }, null, 4)
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("section", _hoisted_4, [
        _createVNode(_component_v_card_title, { class: "d-flex align-center justify-space-between flex-wrap font-size-18-600" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("p", _hoisted_6, [
                _createVNode(Icon, { icon: "history-icon" })
              ]),
              _cache[10] || (_cache[10] = _createTextVNode(" Most Recent Orders ", -1))
            ]),
            _createVNode(_component_v_btn, {
              ripple: false,
              class: "primary-underline-button text-capitalize font-size-12-600 pa-0",
              variant: "plain",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_unref(router).push({ name: 'orders' })))
            }, {
              default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                _createTextVNode(" Show All ", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        }),
        (state.items.length === 0)
          ? (_openBlock(), _createBlock(CardComponent, {
              key: 0,
              class: "font line-height-18 pa-2"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(Icon, { icon: "basket-icon" })
                ]),
                _cache[12] || (_cache[12] = _createElementVNode("div", { class: "font-size-14-400 line-height-18 empty-message-container" }, [
                  _createElementVNode("p", { class: "empty-message-title" }, "Orders"),
                  _createElementVNode("p", null, "You have no confirmed"),
                  _createElementVNode("p", null, "orders")
                ], -1))
              ]),
              _: 1
            }))
          : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(state.items, (order) => {
              return (_openBlock(), _createBlock(OrderCard, {
                key: order.id,
                "button-color": _unref(settingsStore).settings.buttonColor,
                order: order,
                "orders-background-color": _unref(setAppColor)
              }, null, 8, ["button-color", "order", "orders-background-color"]))
            }), 128))
      ])
    ]),
    _: 1
  }))
}
}

})